/* Minka motion: scroll reveals, pinned scroll story, 3D tilt on product cards.
   Everything is skipped for visitors who prefer reduced motion. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  /* ---------- 1. Reveal on scroll ---------- */
  var REVEAL = '.index-section .section-header, .grid-product, .mk-cat, .mk-style, .mk-covers__item, .mk-review, .mk-trust__item, .mk-edit__art a, .mk-edit__copy, .mk-insta a, .mk-footer__news > *, .mk-story__intro, .mk-perks, .mk-bt, .mk-craft__item, .mk-swatch, .mk-srow, .mk-value, .mk-stat, .mk-faq__item, .mk-track__card';
  function initReveal(scope) {
    if (reduce || !('IntersectionObserver' in window)) return;
    root.classList.add('mk-motion');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    var vh = window.innerHeight;
    (scope || document).querySelectorAll(REVEAL).forEach(function (el) {
      if (el.dataset.mkReveal) return;
      el.dataset.mkReveal = '1';
      if (el.getBoundingClientRect().top < vh * 0.92) return; // already on screen: leave visible
      var sibs = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--mk-d', ((sibs % 4) * 90) + 'ms');
      el.classList.add('mk-reveal');
      io.observe(el);
    });
  }

  /* ---------- 2. Pinned scroll story ---------- */
  function initStory(scope) {
    (scope || document).querySelectorAll('[data-mk-story]').forEach(function (sec) {
      if (sec.dataset.ready) return; sec.dataset.ready = '1';
      var steps = sec.querySelectorAll('[data-step]'), frames = sec.querySelectorAll('[data-frame]');
      var bar = sec.querySelector('[data-progress]'), cur = sec.querySelector('[data-current]');
      function activate(i) {
        steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        frames.forEach(function (f, k) { f.classList.toggle('is-active', k === i); });
        if (cur) cur.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) activate(parseInt(e.target.dataset.step, 10)); });
        }, { rootMargin: '-45% 0px -45% 0px' });
        steps.forEach(function (s) { io.observe(s); });
      }
      if (bar) {
        var ticking = false;
        var update = function () {
          var list = sec.querySelector('.mk-story__steps').getBoundingClientRect();
          var total = list.height - window.innerHeight * 0.5;
          var done = Math.min(1, Math.max(0, (window.innerHeight * 0.5 - list.top) / Math.max(total, 1)));
          bar.style.transform = 'scaleX(' + done + ')'; ticking = false;
        };
        window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
        update();
      }
    });
  }

  /* ---------- 3. 3D tilt on product cards (mouse only) ---------- */
  function initTilt() {
    if (reduce || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    document.addEventListener('mousemove', function (e) {
      var card = e.target.closest && e.target.closest('.grid-product__image-mask');
      if (!card) return;
      var r = card.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      card.style.transform = 'perspective(900px) rotateY(' + (x * 7).toFixed(2) + 'deg) rotateX(' + (-y * 7).toFixed(2) + 'deg) scale(1.02)';
      card.classList.add('is-tilting');
    }, { passive: true });
    document.addEventListener('mouseout', function (e) {
      var card = e.target.closest && e.target.closest('.grid-product__image-mask');
      if (card && !card.contains(e.relatedTarget)) { card.style.transform = ''; card.classList.remove('is-tilting'); }
    });
  }

  /* ---------- 4. Mega menu: live cover preview ---------- */
  function initMega() {
    var pick = function (e) {
      var a = e.target.closest && e.target.closest('.mk-mega__link'); if (!a) return;
      var mega = a.closest('[data-mk-mega]'), i = a.dataset.megaI;
      mega.querySelectorAll('.mk-mega__link').forEach(function (l) { l.classList.toggle('is-active', l === a); });
      mega.querySelectorAll('[data-mega-cover]').forEach(function (c) { c.classList.toggle('is-active', c.dataset.megaCover === i); });
    };
    document.addEventListener('mouseover', pick, { passive: true });
    document.addEventListener('focusin', pick);
  }

  function boot(scope) { initReveal(scope); initStory(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); initTilt(); initMega(); });
  else { boot(); initTilt(); initMega(); }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  // Collection pages load more products via AJAX: reveal those too
  var mq = false;
  new MutationObserver(function () {
    if (mq) return; mq = true;
    requestAnimationFrame(function () { mq = false; initReveal(); });
  }).observe(document.body, { childList: true, subtree: true });
})();
